import { useEffect, useRef } from 'react'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import { useMessageStore } from 'hooks/useGlobalContext/useMessageStore'

const useStripeAlert = () => {
  const { stripeConnectData } = useMerchant()
  const { addMessage, removeMessage } = useMessageStore()
  const messageIdRef = useRef<string | null>(null)

  const isStripeOnboarded = stripeConnectData?.hasOnboarded ?? true
  const isStripeConnected = stripeConnectData?.hasConnected ?? true

  useEffect(() => {
    if (isStripeConnected && isStripeOnboarded) {
      if (messageIdRef.current) {
        removeMessage(messageIdRef.current)
        messageIdRef.current = null
      }

      return
    }

    if (messageIdRef.current) {
      return
    }

    const content = isStripeConnected
      ? 'Your Slerp Pay account is connected, but currently unable to transact. Please visit your Stripe Dashboard to finish your onboarding'
      : 'To complete your setup and start transacting, please enter your payment details'
    const label = isStripeConnected
      ? 'Complete onboarding'
      : 'Enter payment details'

    messageIdRef.current = addMessage({
      type: 'cta',
      content,
      action: {
        label,
        to: '/settings/accounts-and-billing'
      }
    })
  }, [isStripeConnected, isStripeOnboarded, addMessage, removeMessage])
}

export default useStripeAlert
